export default "__VITE_ASSET__080ff8c3__"